import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {NgbDropdown, NgbModal} from '@ng-bootstrap/ng-bootstrap';

import {ProfileService} from '../../../../auth/services/profile.service';
import {AuthService} from '../../../../auth/auth.service';
import {SettingsModalComponent} from '../../clinic-control-panel/settings/settings-modal.component';
import {
  PartnerAccountUpdateComponent
} from '../../clinic-control-panel/partner-account-update/partner-account-update.component';
import {PartnerStatus} from "../../../../models/partner.model";
import {PartnerSubscriptionsComponent} from '../../clinic-control-panel/partner-subscriptions/partner-subscriptions.component';

@Component({
  selector: 'app-user-profile-dropdown',
  templateUrl: './user-profile-dropdown.component.html',
  styleUrls: ['./user-profile-dropdown.component.css'],
  standalone: false
})
export class UserProfileDropdownComponent implements OnInit {
  @Input() dropdown?: NgbDropdown;

  constructor(
    private router: Router,
    private authService: AuthService,
    protected profileService: ProfileService,
    private modalService: NgbModal
  ) {
  }

  ngOnInit(): void {
  }

  getInitials(): string {
    const firstname = this.profileService.profile?.firstname || '';
    const lastname = this.profileService.profile?.lastname || '';
    return `${firstname.charAt(0)}${lastname.charAt(0)}`.toUpperCase();
  }

  navigateToProfile(): void {
    this.dropdown?.close();
    if (this.profileService.profile?.role === 'PARTNER') {
      const modalRef = this.modalService.open(PartnerAccountUpdateComponent, {
        size: 'xl',
        backdrop: 'static',
        centered: true, scrollable: true
      });
    }
  }

  navigateToSettings(): void {
    this.dropdown?.close();
    const modalRef = this.modalService.open(SettingsModalComponent, {
      size: 'xl',
      backdrop: 'static',
      centered: true
    });
  }

  openSubscriptions(): void {
    this.dropdown?.close();
    this.modalService.open(PartnerSubscriptionsComponent, {
      size: 'xl',
      backdrop: 'static',
      centered: true,
      scrollable: true,
    });
  }

  logout(): void {
    this.authService.logout();
  }

  isApprovedPartner(): boolean {
    return this.profileService.profile?.role === 'PARTNER' && this.profileService.profile?.partner?.status == PartnerStatus.APPROVED;
  }

  isApprovedOwner(): boolean {
    return this.isApprovedPartner() && this.profileService.isOwner;
  }

  canManageAccountSettings(): boolean {
    return this.profileService.profile?.role === 'ADMIN' ? true : this.profileService.profile?.partner?.status == PartnerStatus.APPROVED;
  }

}
